/****************************************************************************************************************
 * Logic here is consolidated JS extracted from _site-css-js.twig during Craft3 -> Craft4 infrastructure upgrade
 ****************************************************************************************************************/

//
// ! Cookie functions from http://www.quirksmode.org/js/cookies.html
// -------------------------------------------------

// Create cookie
function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else {
        var expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for ( var i = 0; i < ca.length; i++ ) {
        var c = ca[i];
        while ( c.charAt(0) == ' ' ) {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

// Delete cookie
function eraseCookie(name) {
    createCookie(name, "", -1);
}

window.addEventListener('load', () => {
    //using vanilla js because main.min.js is deferred and not loaded
    //loaded preloaded css
    let resources = document.getElementsByClassName('preload-css');

    document.addEventListener("DOMContentLoaded", function () {
        for ( let i = 0; i < resources.length; i++ ) {
            resources[i].rel = 'stylesheet';
        }
    });

    async function supportsWebp() {
        if (!self.createImageBitmap) {
            return false;
        }

        const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
        const blob = await fetch(webpData).then(r => r.blob());
        return createImageBitmap(blob).then(() => true, () => false);
    }

    (async () => {
        if (await supportsWebp()) {
            document.documentElement.classList.add('webp')
        }
        else {
            document.documentElement.classList.add('no-webp')
        }
    })();

    const html = document.documentElement;
    const concertMode = readCookie('ConcertMode');

    if (concertMode) {
        html.classList.add('dark');
    }
    else {
        html.classList.remove('dark');
    }

    $('.nav-link').click(function (event) {
        var id = $(this).attr("href");
        var offset = 0;
        var target = $(id).offset().top - offset;
        $('html, body').animate({ scrollTop: target }, 500);
        $('.nav-checkbox').prop('checked', false);
        event.preventDefault();
    });

    $('.concert-mode-toggle').click(function () {
        if (html.classList.contains('dark')) {
            html.classList.remove('dark');
            eraseCookie('ConcertMode');
        }
        else {
            html.classList.add('dark');
            createCookie('ConcertMode', 'enabled', 30);
        }
    });

    $('body').removeClass('preload');

    $('.language-toggle').click(function (event) {
        var languageToggle = $(this);

        languageToggle.closest('.generic-content-panel').find('.prim-lang-content').toggle('hidden');
        languageToggle.closest('.generic-content-panel').find('.sec-lang-content').toggle('hidden');
        languageToggle.closest('.generic-content-panel').find('.prim-lang-title').toggle('hidden');
        languageToggle.closest('.generic-content-panel').find('.sec-lang-title').toggle('hidden');

        var contentContainer = languageToggle.closest('.generic-content-panel').find('.expandable')
        if (contentContainer.length) {
            if (!contentContainer.hasClass('showing-less')) {
                var additionalHeight = 80;
                setTimeout(function () {
                    contentContainer.css('height', '100%');
                    var contentHeight = contentContainer.height() + additionalHeight;
                    contentContainer.animate({ height: contentHeight }, 300, function () {
                    });
                }, 500);
            }
        }
    });

    $(window).resize(function () {
        if ($(window).width() < 640) {
            $('.expandable').each(function (index) {
                if (!$(this).hasClass('showing-less')) {
                    var additionalHeight = 80;
                    $(this).css('height', '100%');
                    var contentHeight = $(this).height() + additionalHeight;
                    $(this).css({ height: contentHeight });
                }
                else {
                    var imageHeight = ($(this).hasClass('left')) ? $(this).find('img').height() : (($(this).hasClass('top')) ? $(this).find('img').height() : 0);
                    $(this).css({ height: imageHeight + 160 });
                }
            })
        }
    });

    $.fn.extend({
        toggleText: function (a, b) {
            return this.text(this.text() == b ? a : b);
        }
    });

    $('.show-more-less').click(function (event) {
        var visibilityToggle = $(this).find('p');
        var toggleContainer = visibilityToggle.closest('.expandable');
        var showingLessHeight = 160;
        var additionalHeight = 80;
        var imageHeight = (toggleContainer.hasClass('left')) ? toggleContainer.find('img').height() : ((toggleContainer.hasClass('top')) ? toggleContainer.find('img').height() : 0);

        if (toggleContainer.hasClass('showing-less')) {
            toggleContainer.css('height', '100%');
            var contentHeight = toggleContainer.height() + additionalHeight;
            toggleContainer.css({ height: showingLessHeight + imageHeight });
            toggleContainer.animate({ height: contentHeight }, 300, function () {
            });
            toggleContainer.removeClass('showing-less');
            visibilityToggle.toggleText('Show less...', 'Show more...');
        }
        else {
            toggleContainer.animate({ height: showingLessHeight + imageHeight }, 300, function () {
            });
            toggleContainer.addClass('showing-less');
            visibilityToggle.toggleText('Show less...', 'Show more...');
            $('html, body').animate({
                scrollTop: toggleContainer.offset().top
            }, 300);
        }
    });

    // adds additional height to collapsed content with a top or left image set
    $('.expandable.left, .expandable.top').each(function (index) {
        var imageHeight = $(this).find('img').height();
        $(this).css({ height: imageHeight + 160 });
    });
});